import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

interface W2RootGateProps {
  children: React.ReactNode;
}

/**
 * LEGACY-ENTRY SHIM (ADR-0010 trail; D3 — keep one release cycle, then delete
 * after a QA sweep). The tokenized W2 entry moved from `/?t=<token>` to
 * `/e/<token>` (master plan C-1); this catches old bookmarks/seeded links and
 * any missed minting surface (risk R4) and redirects them into the new flow,
 * dropping `t` and preserving every other query param. A PRESENT-but-empty
 * `/?t=` redirects to `/e/` → the branded truncated-link error (same policy as
 * before — finding L2). An ABSENT `t` stays B2C.
 */
export const W2RootGate: React.FC<W2RootGateProps> = ({ children }) => {
  const { pathname, search } = useLocation();
  const params = new URLSearchParams(search);
  const token = params.get('t');

  if (pathname === '/' && token !== null) {
    params.delete('t');
    const rest = params.toString();
    return (
      <Navigate
        to={`/e/${encodeURIComponent(token)}${rest ? `?${rest}` : ''}`}
        replace
      />
    );
  }

  return <>{children}</>;
};
